<template>
  <div>
    <site-banner title="Become A Reseller" lead="Add an additional passive income stream to your business with our lucrative reseller program." />

    <div class="px-6 py-12 mx-auto max-w-7xl lg:grid lg:grid-cols-2 lg:gap-8">
      <div class="flex flex-col justify-center">
        <h2 class="mb-10 text-2xl font-extrabold tracking-tight text-gray-900">
          Why Resell Fleetbeacon?
        </h2>
        <dl class="space-y-10">
          <div v-for="feature in features" :key="feature.icon" class="flex">
            <div class="flex items-center justify-center flex-none w-12 h-12 mr-6 text-white bg-indigo-500 rounded-lg">
              <fa :icon="['fas', feature.icon]" class="text-xl" />
            </div>
            <div>
              <dt class="text-lg font-bold leading-6 text-gray-900">
                {{ feature.title }}
              </dt>
              <dd class="mt-2 text-base text-gray-500">
                {{ feature.body }}
              </dd>
            </div>
          </div>
        </dl>
      </div>

      <div class="relative z-10 max-w-xl p-8 mx-auto mt-12 bg-white rounded-lg shadow-xl lg:mt-0">
        <div>
          <div class="p-12 text-center" v-if="successful" id="success">
            <div class="max-w-xs mx-auto text-lg">
              <checkmark size="2rem" />
              <p class="mt-4 text-xl font-bold">Thanks for signing up!</p> 
              <p class="mt-2 text-gray-500">
                We will be in touch soon with next steps.
              </p>
            </div>
          </div>
          <form @submit.prevent="submit" class="grid grid-cols-1 gap-y-6" v-else>
            <fieldset>
              <label for="name" class="form-label">
                Your name:
              </label>
              <input id="name" class="py-3 shadow-sm form-input" v-model="form.name" required>
            </fieldset>
            <fieldset>
              <label for="email" class="form-label">
                Your company email address:
              </label>
              <input id="email" type="email" class="py-3 shadow-sm form-input" v-model="form.email" required>
            </fieldset>
            <fieldset>
              <label for="company" class="form-label">
                Company name:
              </label>
              <input id="company" class="py-3 shadow-sm form-input" v-model="form.company" required>
            </fieldset>
            <fieldset>
              <label class="form-label">
                What country are you based in?
              </label>
              <country-select class="w-full py-3 form-select" v-model="form.country" />
            </fieldset>
            <fieldset>
              <button type="submit" class="w-full btn btn-primary btn-xl" v-submitting="submitting">
                Sign Up
              </button>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkmark from '@/components/Checkmark'
import SiteBanner from '@/components/SiteBanner'

export default {
  name: 'Reseller',
  
  components: { 
    Checkmark,
    SiteBanner
  },

  data () {
    return {
      successful: false,
      submitting: false,
      form: {
        subject: 'New Reseller Sign Up on Fleetbeacon',
        name: '',
        email: '',
        company: '',
        country: ''
      },
      features: [
        {
          icon: 'sack-dollar',
          title: 'Generous Recurring Commission',
          body: `You can earn 20% recurring commission on all of your sales provided you keep selling. That means if you sell a subscription worth $100 month, you earn $20 a month for the lifetime of that subscription.`
        },
        {
          icon: 'hands-helping',
          title: 'Direct Support',
          body: `The last thing you want when selling someone else's product is to be left in the dark. We'll give you marketing resources, and will always be available to help you to answer questions and close deals.`
        },
        {
          icon: 'file-contract',
          title: 'Dead Simple Contract',
          body: `We hate complexity, so we keep our terms simple and easy to understand, just like our products. Our reseller agreement is literally just two pages long.`
        }
      ]
    }
  },

  methods: {
    async submit () {
      try {
        this.submitting = true
        await this.$api.post('site/form', this.form)
        this.successful = true
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>